export const userActionTypes = {
  SET_ALL_JOBS: "SET_ALL_JOBS",
  TOGGLE_ROLE: "TOGGLE_ROLE",
};
